import { KeyboardEvent, SyntheticEvent } from 'react';

// Named key values from https://www.w3.org/TR/uievents-key/#named-key-attribute-values; add a key here when one is needed
type KeyName = 'ArrowDown' | 'ArrowUp' | 'End' | 'Enter' | 'Escape' | 'Home' | 'Tab';

// MUI passes the key press that closed a menu to onClose, such as Escape, Tab or Enter on an option
export const isKeyboardEvent = (event: SyntheticEvent<unknown>): event is KeyboardEvent<unknown> => 'key' in event;

export const isKeyPress = (event: SyntheticEvent<unknown>, key: KeyName) => isKeyboardEvent(event) && event.key === key;
